import { Text } from '@chakra-ui/react';

import { MapsHeaderProps } from './MapWidgetMenu.types';

export const MapHeader = ({ label }: MapsHeaderProps) => {
  return (
    <Text as='h2' fontSize='sm' lineHeight={5} fontWeight='semibold'>
      {label}
    </Text>
  );
};
